<template>
<div class="outer">
  <div class="wrap">
  <div id="login">
    <div id="header">
      <div v-show="view == 0">
      TSV Kunreuth Login
      </div>
      <div v-show="view == 1">
      Neues Passwort setzten
      </div>
      <div v-show="view == 2">
      TSV Kunreuth Login
      </div>
      </div>
      <div id="info" :class="classinfo">{{msg}}</div>
      <div id="left">
        <img src="/static/img/logo.png" width="119" height="148" alt="TSV Kunreuth Verein Fussball" />
      </div> 
      <div id="right"> 
        <div v-show="view == 2" class="forgetPassword">
          <p class="desc">E-Mail <strong><u>oder</u></strong> Benutzer eingeben um ein neues Passwort per E-Mail zu erhalten:</p>
          <p><input tabindex="2" ref="user_email" type="text" v-model="user_email" name="user_email" placeholder="E-Mail oder Benutzer" spellcheck="false"/></p>
          <p><button tabindex="3" class="btn senden" v-on:click="forgetPasswordSend">SENDEN</button></p>
        </div>
        <div v-show="view == 1" class="newpasswordform">
          <p><input tabindex="1" ref="password1" type="password" @click="select" v-model="password1" name="password1" placeholder="Passwort" spellcheck="false" /></p>
          <p><input tabindex="2" ref="password2" type="password" v-model="password2" name="password2" placeholder="Passwort Wdh." spellcheck="false"/></p>
          <p><button tabindex="3" class="btn senden" v-on:click="passwordChange">SENDEN</button></p>
        </div>
        <div v-show="view == 0" class="loginform">  
          <!-- <form class="loginform" enctype="application/x-www-form-urlencoded" action="api/login.pl" method="post">  -->
          <p><input tabindex="1" ref="loginname" type="text" v-on:keyup="keyup" @click="select" v-model="loginname" name="loginname" placeholder="Benutzer" spellcheck="false" /></p>
          <p>
            <input tabindex="2" ref="password" type="password" v-on:keyup="keyup" v-model="password" name="password" placeholder="Passwort" spellcheck="false"/>
            <span class="link" v-on:click="forgetPassword">Benutzer oder Passwort vergessen?</span>
          </p>
          
          <p><button tabindex="3" class="btn anmelden" v-on:click="login">ANMELDEN</button></p>
          <!-- </form> -->
        </div>
      </div>
      </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      loginname: '',
      password: '',
      showinfo: false,
      error: false,
      msg: '',
      status: 0,
      password1: '',
      password2: '',
      view: 0,
      user_id: 0,
      user_email: ''
    }  
  },
  computed: {
    classinfo: function() {
      var ReturnValue = [this.status]
      if(this.showinfo || this.error){
        ReturnValue.push('show');
      }
      return ReturnValue;
    },
  },
  mounted: function () {

    

    this.$http.get('/api/checklogin.pl').then(function (response) {
      if(this.$route.params.regnummer > 0 && this.$route.params.user_id > 0 && response.data.user.logged_in == 1){
        this.$http.get('/api/logout.pl').then(function (response) {
          this.$store.state.user = response.data.user
        });
      }
      else if( response.data.user.logged_in == 1 ){ 
        this.$router.push({ name: 'admin' })
        this.$router.go({ name: 'admin' })
      }
    });

    if(this.$route.params.status == "notloggedin"){
      this.showInfo('info', 'Benutzer nicht eingeloggt - Sitzung abgelaufen')
    }


    if(this.$route.params.status == "email" && this.$route.params.regnummer > 0 && this.$route.params.user_id > 0){
       this.$http.post('/api/login.pl', {action: "email", regnummer: this.$route.params.regnummer, user_id: this.$route.params.user_id}, {headers: {'Content-Type': 'application/json'}}).then(function (response) {
        console.log(response.data)
        if(response.data.status == 1){
          this.showInfo('info', "E-Mail '" + response.data.email + "' wurde erfolgreich bestätigt")
        }
        else if(response.data.status == 0){
          this.showInfo('error', "E-Mail konnte nicht bestätigt werden")
        }
        else if(response.data.status == 2){
          this.showInfo('error', "Bestätigungslink ungültig (48 Stunden)")
        }
      }); 
    }
    
    this.$nextTick(() => this.$refs.loginname.select())
  },
  
  methods: {
    select(event) {
      console.log(event.target.select())
    },
    login: function (event) {
      if(this.loginname.length == 0){
        this.showInfo('error', 'Benutzer fehlt')
        return;
      }
      if(this.password.length == 0){
        this.showInfo('error', 'Passwort fehlt')
        return;
      }
      this.$http.post('/api/login.pl', { loginname: this.loginname, password: this.password }, {headers: {'Content-Type': 'application/json'}}).then(function (response) {
        this.user = response.data
        this.showinfo = false;
        if( this.user.logged_in == 1 && this.user.re_password == 1 ){
          this.view = 1
          this.user_id = this.user.user_id
          this.$nextTick(() => this.$refs.password1.select())
        }
        else if( this.user.logged_in == 1 ) {
          this.$router.push({ name: 'admin' })
          this.$router.go({ name: 'admin' })
        }
        else{
          this.showInfo('error', 'Login fehlgeschlagen')  
        }
      });  
    },
    passwordChange: function (event){
      this.$http.post('/api/login.pl', { action: "newpassword", user_id: this.user_id, password: this.password, password1: this.password1, password2: this.password2 }, {headers: {'Content-Type': 'application/json'}}).then(function (response) {
        console.log(response.data)
        this.showinfo = false
        if( response.data.status == 2 ){
          this.showInfo('error', 'Passwörter stimmen nicht überein')  
        }
        else if( response.data.status == 0 ){
          this.showInfo('error', 'Ein Fehler ist aufgetreten')  
        }
        else{
          this.showInfo('info', 'Passwort wurde geändert')   
          this.view = 0
          this.$nextTick(() => this.$refs.loginname.select())
        }
      }); 
    },
    forgetPasswordSend: function (event){
      this.$http.post('/api/login.pl', { action: "forgetPassword", user_email: this.user_email }, {headers: {'Content-Type': 'application/json'}}).then(function (response) {
        this.showinfo = false
        if( response.data.status == 2 ){
          this.showInfo('error', 'Benutzer oder E-Mail nicht gefunden')  
        }
        else if( response.data.status == 0 ){
          this.showInfo('error', 'Ein Fehler ist aufgetreten')  
        }
        else{
          this.showInfo('info', 'Es wurde eine E-Mail gesendet')   
          this.view = 0
          this.$nextTick(() => this.$refs.loginname.select())
        }
      });
    },
    forgetPassword: function (event){
      this.showinfo = false
      this.view = 2
      this.$nextTick(() => this.$refs.user_email.select())
    },
    keyup: function (event) {
      if(this.error){
        this.error = false;
        this.msg = ''
      }
    },
    showInfo(status, msg){
      if(this.status == 'error'){
        this.error = true
      }
      this.showinfo = true;
      this.status = status
      this.msg = msg
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
body{
  background: none repeat scroll 0 0 #F7F7F7;
}
.outer {
    display: table;
    position: absolute;
    height: 70%;
    width: 100%;
    top: 0;
    left: 0;
}
.wrap {
    display: table-cell;
    vertical-align: middle;
}
#login {
  margin: 0 auto;
  width: 380px;
  background-color: white;
  display: flex;
  flex-flow: row wrap;
  
}
#header, #info {
  padding: 0;
  flex: 1 100%;  
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  
}
#header{
  font-size: 1.2rem;
  font-weight: bold;
  letter-spacing: 1px;
  background-color: #1D82B6;
  height: 30px;
  color: white;
}

#info{
  border-top: none;
  height: 0; /* 28px */
  -webkit-transition: height 0.2s ease-out;
  -moz-transition: height 0.2s ease-out;
  transition: height 0.2s ease-out;
  font-size: 0.9rem;
  opacity: 0;
  overflow: hidden;
  line-height: 0;
}

#info.show{
  height: 28px;
  -webkit-transition: height 0.2s ease-in;
  -moz-transition: height 0.2s ease-in;
  transition: height 0.2s ease-in;
  -webkit-animation: fadein 0.3s ease-in alternate 1;
  -moz-animation: fadein 0.3s ease-in alternate 1; 
  animation: fadein 0.3s ease-in alternate 1;
  opacity: 1;
}

@-webkit-keyframes fadein {
    from { opacity: 0; }
    to { opacity: 1; }
}

@-moz-keyframes fadein {
    from { opacity: 0; }
    to { opacity: 1; }
}

@keyframes fadein {
    from { opacity: 0; }
    to { opacity: 1; }
}

#login input, #login button{
  width: 100%;
}
.loginform p, .loginform p:first-child{
  margin: 10px 0; 
}

.newpasswordform p{
  margin: 14px 0; 
}
.link{
  color: #1D82B6;
  text-decoration: underline;
  cursor: pointer;
  font-size: 0.8rem;
  font-family: Arial,sans-serif;
}
.link:hover{
  color: #239cda;
}

.forgetPassword p.desc{
  font-size: 0.9rem;
  font-family: Arial,sans-serif;
  margin-top: 14px;
}


#login #left{
  padding-left: 4px;
  flex: 1 0;
  border-left: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}
#login #right{
  width: 100%;
  padding: 0 10px;
  flex: 2 0;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}

#info{
  border-right: 1px solid #ccc;
  border-left: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue